<div class="container">
  <div class="row">
    <div class="col-12 col-lg-6 d-none d-lg-block">
      <h5 class="">{{ 'account.member.card.title' | translate }}</h5>
      <fgb-member-card></fgb-member-card>
    </div>
    <div class="col-12 col-lg-6">
      <h5 class="">{{ 'account.details.title' | translate }}</h5>
      <fgb-account-details></fgb-account-details>
    </div>
  </div>
</div>
